// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__24EOE","footer":"ReportModalFilter_footer__3QfLl"};